import React, { useState, lazy, Suspense } from "react";
import "./App.css";
import "./styles/styles.scss";
import { storage } from "./Firebase";
import "bootstrap/dist/css/bootstrap.min.css";
import { db } from "./Firebase";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Navbar from "./navbar/Navbar";
import Footer from "./footer/Footer";
import { getDownloadURL, ref } from "firebase/storage";
import Home from "./home/Home";
import HealthSustainability from "./health_sustainability/HealthSustainability";
import { useMediaPredicate } from "react-media-hook";
import { ParallaxProvider } from "react-scroll-parallax";
const AboutUs = lazy(() => import("./about_us/AboutUs"));
const CorsoPage = lazy(() => import("./corso_page/CorsoPage"));
const Careers = lazy(() => import("./careers/Careers"));
const Press = lazy(() => import("./press/Press"));
const ContactUs = lazy(() => import("./contact_us/ContactUs"));
const Collections = lazy(() => import("./collection/Collections"));
const Companies = lazy(() => import("./companies/Companies"));
const GalerieCapital = lazy(() => import("./galerie_capital/GalerieCapital"));
const Team = lazy(() => import("./team/Team"));
const VillagePark = lazy(() => import("./village_park/VillagePark"));
const Management = lazy(() => import("./management/Management"));
const Development = lazy(() => import("./development/Development"));
const NotFound = lazy(() => import("./error_page/NotFound"));
const Portfolio = lazy(() => import("./portfolio/Portfolio"));
// Staging page consolidating About Us + Health Sustainability — not linked
// in nav yet, see src/our_story/OurStory.js.
const OurStory = lazy(() => import("./our_story/OurStory"));

// Team Portfolio Pages
// Deactivated for now along with the /JoshuaPeterson route below.
// const JoshuaPeterson = lazy(() => import("./team_portfolios/JoshuaPeterson"));

// Press Article Pages
const May202026 = lazy(() => import("./press/articles/May-20-2026"));

function App() {
  const max_width2 = useMediaPredicate("(max-width: 1230px)");
  const [navBackground, setNavBackground] = useState("white");
  const [navText, setNavText] = useState("black");
  const [navHoverDim, setNavHoverDim] = useState(false);

  const slide_right = {
    initial: max_width2 ? { x: 0 } : { x: -25, opacity: 0 },
    whileInView: { x: 0, opacity: 1 },
    transition: max_width2 ? { duration: 0 } : { type: "tween", duration: 0.7 },
  };
  const slide_left = {
    initial: max_width2 ? { x: 0 } : { x: 25, opacity: 0 },
    whileInView: { x: 0, opacity: 1 },
    transition: max_width2 ? { duration: 0 } : { type: "tween", duration: 0.7 },
  };
  const handleCurrentPage = () => {
    if (window.location.pathname !== "/contact") {
      setNavBackground("white");
      setNavText("black");
    }
  };

  const getSingleImage = (path, id) => {
    getDownloadURL(ref(storage, `galerie-corporate/${path}`))
      .then((url) => {
        const img = document.getElementById(id);
        try {
          img.setAttribute("src", url);
        } catch (error) {}
      })
      .catch((error) => {
        // Handle any errors
        console.log(error);
      });
  };

  return (
    <ParallaxProvider>
      <BrowserRouter>
        <div className="App">
          <Navbar
            backgroundColor={navBackground}
            textColor={navText}
            setNavHoverDim={setNavHoverDim}
            navHoverDim={navHoverDim}
          />
          <div style={{ paddingBottom: "100px" }}></div>
          <Routes>
            <Route
              path="/"
              element={
                <Home
                  slide_right={slide_right}
                  handleCurrentPage={handleCurrentPage}
                  storage={storage}
                  db={db}
                  getSingleImage={getSingleImage}
                  setNavBackground={setNavBackground}
                  setNavText={setNavText}
                />
              }
            />
            <Route
              path="/corso"
              element={
                <Suspense fallback={<>...</>}>
                  <CorsoPage
                    slide_left={slide_left}
                    slide_right={slide_right}
                    storage={storage}
                    handleCurrentPage={handleCurrentPage}
                    db={db}
                  />
                </Suspense>
              }
            />
            <Route
              path="/careers"
              element={
                <Suspense fallback={<>...</>}>
                  <Careers
                    slide_left={slide_left}
                    slide_right={slide_right}
                    handleCurrentPage={handleCurrentPage}
                    storage={storage}
                    db={db}
                    getSingleImage={getSingleImage}
                  />
                </Suspense>
              }
            />
            <Route
              path="/press"
              element={
                <Suspense fallback={<>...</>}>
                  <Press
                    slide_right={slide_right}
                    handleCurrentPage={handleCurrentPage}
                    db={db}
                    storage={storage}
                  />
                </Suspense>
              }
            />
            <Route
              path="/contact"
              element={
                <Suspense fallback={<>...</>}>
                  <ContactUs
                    slide_right={slide_right}
                    db={db}
                    handleCurrentPage={handleCurrentPage}
                    storage={storage}
                    getSingleImage={getSingleImage}
                    setBackgroundColor={setNavBackground}
                    setTextColor={setNavText}
                  />
                </Suspense>
              }
            />
            <Route
              path="/collections"
              element={
                <Suspense fallback={<>...</>}>
                  <Collections
                    slide_left={slide_left}
                    slide_right={slide_right}
                    Collections
                    handleCurrentPage={handleCurrentPage}
                    storage={storage}
                    db={db}
                    getSingleImage={getSingleImage}
                  />
                </Suspense>
              }
            />
            <Route
              path="/about"
              element={
                <Suspense fallback={<>...</>}>
                  <AboutUs
                    slide_right={slide_right}
                    handleCurrentPage={handleCurrentPage}
                    storage={storage}
                    db={db}
                    getSingleImage={getSingleImage}
                  />
                </Suspense>
              }
            />
            <Route
              path="/companies"
              element={
                <Suspense fallback={<>...</>}>
                  <Companies
                    slide_left={slide_left}
                    slide_right={slide_right}
                    handleCurrentPage={handleCurrentPage}
                    storage={storage}
                    db={db}
                    getSingleImage={getSingleImage}
                  />
                </Suspense>
              }
            />
            <Route
              path="/capital"
              element={
                <Suspense fallback={<>...</>}>
                  <GalerieCapital
                    slide_left={slide_left}
                    slide_right={slide_right}
                    handleCurrentPage={handleCurrentPage}
                    setNavBackground={setNavBackground}
                    setNavText={setNavText}
                  />
                </Suspense>
              }
            />
            <Route
              path="/team"
              element={
                <Suspense fallback={<>...</>}>
                  <Team
                    slide_left={slide_left}
                    slide_right={slide_right}
                    handleCurrentPage={handleCurrentPage}
                    storage={storage}
                    db={db}
                    getSingleImage={getSingleImage}
                  />
                </Suspense>
              }
            />
            <Route
              path="/portfolio"
              element={
                <Suspense fallback={<>...</>}>
                  <Portfolio
                    slide_right={slide_right}
                    handleCurrentPage={handleCurrentPage}
                  />
                </Suspense>
              }
            />
            <Route
              path="/ourstory"
              element={
                <Suspense fallback={<>...</>}>
                  <OurStory
                    slide_right={slide_right}
                    handleCurrentPage={handleCurrentPage}
                  />
                </Suspense>
              }
            />
            <Route
              path="/villagepark"
              element={
                <Suspense fallback={<>...</>}>
                  <VillagePark
                    slide_left={slide_left}
                    slide_right={slide_right}
                    handleCurrentPage={handleCurrentPage}
                    storage={storage}
                    db={db}
                    getSingleImage={getSingleImage}
                  />
                </Suspense>
              }
            />
            <Route
              path="/management"
              element={
                <Suspense fallback={<>...</>}>
                  <Management
                    slide_left={slide_left}
                    slide_right={slide_right}
                    handleCurrentPage={handleCurrentPage}
                    storage={storage}
                    db={db}
                    setNavBackground={setNavBackground}
                    setNavText={setNavText}
                  />
                </Suspense>
              }
            />
            <Route
              path="/development"
              element={
                <Suspense fallback={<>...</>}>
                  <Development
                    slide_left={slide_left}
                    slide_right={slide_right}
                    handleCurrentPage={handleCurrentPage}
                    setNavBackground={setNavBackground}
                    setNavText={setNavText}
                  />
                </Suspense>
              }
            />
            <Route
              path="/healthsustainability"
              element={
                <Suspense fallback={<>...</>}>
                  <HealthSustainability
                    slide_left={slide_left}
                    slide_right={slide_right}
                    handleCurrentPage={handleCurrentPage}
                    storage={storage}
                  />
                </Suspense>
              }
            />
            {/* Deactivated for now — no bio pages are currently linked to
            (Team.js/Management.js/ManagementDraft.js all pass bio_slug:
            null for Joshua Peterson). Route and lazy import kept commented out,
            not deleted, so this can be switched back on later.
            <Route
              path="/JoshuaPeterson"
              element={
                <Suspense fallback={<>...</>}>
                  <JoshuaPeterson
                    slide_left={slide_left}
                    slide_right={slide_right}
                    handleCurrentPage={handleCurrentPage}
                    storage={storage}
                  />
                </Suspense>
              }
            />
            */}
            <Route
              path="/press/may-20-2026"
              element={
                <Suspense fallback={<>...</>}>
                  <May202026 handleCurrentPage={handleCurrentPage} />
                </Suspense>
              }
            />
            <Route
              path="*"
              element={
                <Suspense fallback={<>...</>}>
                  <NotFound />
                </Suspense>
              }
            />
          </Routes>

          <Footer
            backgroundColor={navBackground}
            textColor={navText}
          />
          <div className={`overlay ${navHoverDim ? "visible" : ""}`}></div>
        </div>
      </BrowserRouter>
    </ParallaxProvider>
  );
}

export default App;
